import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const app = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

if (rootElement.innerHTML.trim()) {
  // Page is pre-rendered — defer hydration to reduce Total Blocking Time.
  // Content is already visible; hydration just adds interactivity.
  const hydrate = () => ReactDOM.hydrateRoot(rootElement, app);
  if ('requestIdleCallback' in globalThis) {
    requestIdleCallback(hydrate);
  } else {
    setTimeout(hydrate, 1);
  }
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
